import { render, staticRenderFns } from "./StormIcon.vue?vue&type=template&id=6c63b5e4&"
import script from "./StormIcon.vue?vue&type=script&lang=js&"
export * from "./StormIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports